import { render, staticRenderFns } from "./superdocument.vue?vue&type=template&id=e1c623ea&scoped=true"
import script from "./superdocument.vue?vue&type=script&lang=js"
export * from "./superdocument.vue?vue&type=script&lang=js"
import style0 from "./superdocument.vue?vue&type=style&index=0&id=e1c623ea&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c623ea",
  null
  
)

export default component.exports